import { render, staticRenderFns } from "./nxdb.vue?vue&type=template&id=4f491a6e&scoped=true"
import script from "./nxdb.vue?vue&type=script&lang=js"
export * from "./nxdb.vue?vue&type=script&lang=js"
import style0 from "./nxdb.vue?vue&type=style&index=0&id=4f491a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f491a6e",
  null
  
)

export default component.exports